/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_PortugueseInputs */

const en_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portuguese`)
};

const fr_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portugais`)
};

const de_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portugiesisch`)
};

const it_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portoghese`)
};

const ru_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`португальский`)
};

const es_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`portugués`)
};

const zh_cn2_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`葡萄牙语`)
};

const ja_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポルトガル語`)
};

const hi_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुर्तगाली`)
};

const pt_pt2_speechmatics_target_language_portuguese = /** @type {(inputs: Speechmatics_Target_Language_PortugueseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

/**
* | output |
* | --- |
* | "Portuguese" |
*
* @param {Speechmatics_Target_Language_PortugueseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_portuguese = /** @type {((inputs?: Speechmatics_Target_Language_PortugueseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_PortugueseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_portuguese(inputs)
	if (locale === "de") return de_speechmatics_target_language_portuguese(inputs)
	if (locale === "it") return it_speechmatics_target_language_portuguese(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_portuguese(inputs)
	if (locale === "es") return es_speechmatics_target_language_portuguese(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_portuguese(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_portuguese(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_portuguese(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_portuguese(inputs)
	return en_speechmatics_target_language_portuguese(inputs)
});